import { render } from "./HeroArea.vue?vue&type=template&id=449be692"
import script from "./HeroArea.vue?vue&type=script&lang=js"
export * from "./HeroArea.vue?vue&type=script&lang=js"

import "./HeroArea.vue?vue&type=style&index=0&id=449be692&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__